
const introBannerData = {
	background: {
		desktop: "/assets/images/intro-banner/banner-about.jpg",
		mobile: "",
		alt: "Who we are",
	},
	title: "Who we are",
	description: "We invest in partnerships and proven approaches that drive deep, scalable, systems-wide improvements."
}

export { introBannerData };
